export default __webpack_public_path__ + "static/media/MNT.fba98586.png";